document.addEventListener('DOMContentLoaded', function() {
    window.addEventListener('scroll', function() {
        var wHeight = window.innerHeight;
        var scrollAmount = window.scrollY;
        document.querySelectorAll('.cc_stockluck_lp_wrap .cc_scrollanime').forEach(function(el) {
            var rect = el.getBoundingClientRect();
            var targetPosition = rect.top + scrollAmount;
            if (scrollAmount > targetPosition - wHeight + 60) {
                el.classList.add('cc_fadeInDown');
            }
        });
    });
});

(function(d) {
    var config = {
    kitId: 'kff2dto',
    scriptTimeout: 3000,
    async: true
    },
    h=d.documentElement,t=setTimeout(function(){h.className=h.className.replace(/\bwf-loading\b/g,"")+" wf-inactive";},config.scriptTimeout),tk=d.createElement("script"),f=false,s=d.getElementsByTagName("script")[0],a;h.className+=" wf-loading";tk.src='https://use.typekit.net/'+config.kitId+'.js';tk.async=true;tk.onload=tk.onreadystatechange=function(){a=this.readyState;if(f||a&&a!="complete"&&a!="loaded")return;f=true;clearTimeout(t);try{Typekit.load(config)}catch(e){}};s.parentNode.insertBefore(tk,s)
})(document);

document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.cc_stockluck_lp_faq_pull_tips_accodion_box').forEach(function(box) {
        var btn = box.querySelector('.cc_stockluck_lp_faq_pull_tips_accodion_button');
        if (!btn) return;
        btn.addEventListener('click', function() {
            box.classList.toggle('cc_js_accodion_active');
            var main = box.querySelector('.cc_stockluck_lp_faq_pull_tips_accodion_main');
            if (main) {
                main.style.display = box.classList.contains('cc_js_accodion_active') ? 'block' : 'none';
            }
        });
    });
});
